export const elections20221Mixin = {
    created() {
        let last_known_scroll_position = window.scrollY;
        let ticking = false;
        const _self = this;
        
        _self.handleScroll(last_known_scroll_position);
        window.addEventListener('scroll', function (e) {
            last_known_scroll_position = window.scrollY;
            if (!ticking) {
                window.requestAnimationFrame(function () {
                    _self.handleScroll(last_known_scroll_position);
                    ticking = false;
                });
            }
            ticking = true;
        });
    },
    methods: {
        handleScroll: function (scrollY) {
            this.showHeader = scrollY > 200;
        },
    },
    data: function () {
        return {
            showHeader: false
        }
    }
};